<template>
  <div class="order-management">
    <el-form :inline="true" :model="searchForm" class="demo-form-inline">
      <el-form-item label="订单号">
        <el-input v-model="searchForm.orderNo" placeholder="请输入订单号"></el-input>
      </el-form-item>
      <el-form-item label="乘客手机号">
        <el-input v-model="searchForm.phone" placeholder="请输入乘客手机号"></el-input>
      </el-form-item>
      <el-form-item label="驾驶员手机号">
        <el-input v-model="searchForm.driverPhone" placeholder="请输入驾驶员手机号"></el-input>
      </el-form-item>
      <el-form-item label="下单时间">
        <el-date-picker
          v-model="searchForm.dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="订单状态">
        <el-select v-model="searchForm.status" placeholder="请选择订单状态">
        <el-option label="全部" value=""></el-option>
        <el-option label="待接单" value="0"></el-option>
        <el-option label="已接单" value="1"></el-option>
        <el-option label="行程中" value="2"></el-option>
        <el-option label="已完成" value="3"></el-option>
        <el-option label="已取消" value="4"></el-option>
      </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="search">查询</el-button>
        <el-button @click="reset">重置</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="orderList" border stripe>
      <el-table-column prop="orderNo" label="订单号"></el-table-column>
      <!-- <el-table-column prop="userName" label="乘客姓名"></el-table-column> -->
      <el-table-column prop="userPhone" label="乘客手机号"></el-table-column>
      <el-table-column prop="driverPhone" label="驾驶员手机号"></el-table-column>
      <el-table-column prop="startAddress" label="起点"></el-table-column>
      <!-- <el-table-column prop="endAddress" label="终点"></el-table-column> -->
      <el-table-column prop="createTime" label="下单时间"></el-table-column>
      <el-table-column prop="acceptTime" label="接单时间"></el-table-column>
      <el-table-column prop="finishTime" label="完成时间"></el-table-column>
      <el-table-column prop="status" label="订单状态">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 0 ? 'warning' : scope.row.status === 1 ? 'primary' : scope.row.status === 2 ? 'info' : scope.row.status === 3 ? 'success' : 'danger'">
            {{ scope.row.status === 0 ? '待接单' : scope.row.status === 1 ? '已接单' : scope.row.status === 2 ? '行程中' : scope.row.status === 3 ? '已完成' : '已取消' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="viewDetail(scope.row)">查看详情</el-button>
          <el-button type="text" @click="cancelOrder(scope.row)">取消订单</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>

    <!-- 订单详情弹窗 -->
    <el-dialog
      title="订单详情"
      :visible.sync="dialogVisible"
      width="700px"
      append-to-body>
      <div class="order-detail">
        <el-descriptions :column="2" border>
          <el-descriptions-item label="订单号">{{ orderDetail.orderNo }}</el-descriptions-item>
          <el-descriptions-item label="订单状态">
            <el-tag :type="orderDetail.status === 0 ? 'warning' : orderDetail.status === 1 ? 'primary' : orderDetail.status === 2 ? 'info' : orderDetail.status === 3 ? 'success' : 'danger'">
              {{ orderDetail.status === 0 ? '待接单' : orderDetail.status === 1 ? '已接单' : orderDetail.status === 2 ? '行程中' : orderDetail.status === 3 ? '已完成' : '已取消' }}
            </el-tag>
          </el-descriptions-item>
          <!-- <el-descriptions-item label="乘客姓名">{{ orderDetail.userName }}</el-descriptions-item> -->
          <el-descriptions-item label="乘客手机号">{{ orderDetail.userPhone }}</el-descriptions-item>
          <el-descriptions-item label="驾驶员姓名">{{ orderDetail.driverName }}</el-descriptions-item>
          <el-descriptions-item label="驾驶员手机号">{{ orderDetail.driverPhone }}</el-descriptions-item>
          <el-descriptions-item label="起点地址" :span="2">{{ orderDetail.startAddress }}</el-descriptions-item>
          <!-- <el-descriptions-item label="终点地址" :span="2">{{ orderDetail.endAddress }}</el-descriptions-item> -->
          <el-descriptions-item label="下单时间">{{ orderDetail.createTime }}</el-descriptions-item>
          <el-descriptions-item label="接单时间">{{ orderDetail.acceptTime || '-' }}</el-descriptions-item>
          <el-descriptions-item label="开始时间">{{ orderDetail.startTime || '-' }}</el-descriptions-item>
          <el-descriptions-item label="结束时间">{{ orderDetail.finishTime || '-' }}</el-descriptions-item>
        </el-descriptions>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { doPost } from '../../api/api.js'

export default {
  name: 'OrderManagement',
  data () {
    return {
      searchForm: {
        orderNo: '',
        phone: '',
        driverPhone: '',
        dateRange: null,
        status: ''
      },
      orderList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      orderDetail: {}
    }
  },
  mounted () {
    this.getOrderList()
  },
  methods: {
    getOrderList () {
      let params = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        orderNo: this.searchForm.orderNo,
        userPhone: this.searchForm.phone,
        driverPhone: this.searchForm.driverPhone,
        status: this.searchForm.status
      }
      if (this.searchForm.dateRange && this.searchForm.dateRange.length === 2) {
        params.createTimeStart = this.searchForm.dateRange[0]
        params.createTimeEnd = this.searchForm.dateRange[1]
      }
      doPost('/order/getPageList', params).then(res => {
        if (res.code === 200) {
          this.orderList = res.result.list
          this.total = res.result.total
        }
      })
    },
    search () {
      this.currentPage = 1
      this.getOrderList()
    },
    reset () {
      this.searchForm = {
        orderNo: '',
        phone: '',
        driverPhone: '',
        dateRange: null,
        status: ''
      }
      this.search()
    },
    viewDetail (row) {
      // 直接使用当前行数据作为详情，避免额外API调用
      this.orderDetail = row
      this.dialogVisible = true
    },
    cancelOrder (row) {
      this.$confirm('确定要取消该订单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        doPost('/order/cancel', { id: row.id }).then(res => {
          if (res.code === 200) {
            this.$message({ type: 'success', message: '取消成功!' })
            this.getOrderList()
          }
        })
      }).catch(() => {
        this.$message({ type: 'info', message: '已取消取消' })
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.getOrderList()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getOrderList()
    }
  }
}
</script>

<style scoped>
.order-management {
  padding: 20px;
}
.demo-form-inline {
  margin-bottom: 20px;
}
.order-detail {
  padding: 10px 0;
}
.el-descriptions {
  margin-bottom: 0;
}
.el-descriptions__cell {
  padding: 12px 16px;
}
.el-descriptions__label {
  font-weight: 500;
}
</style>
